// extracted by mini-css-extract-plugin
export default {"topSectionContent":"ge1hAyd7"};